export const GDPR_KEY_AGREED = 'dibs-gdpr-agreed';
export const GDPR_KEY_NOT_APPLICABLE = 'dibs-gdpr-not-applicable';
